import { createContext, useContext, useReducer } from "react";

export const WarehousingStore = createContext<IContextProps>(null);

interface IContextProps {
  state: IState;
  dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type; payload };

class Search {
  keywords: string;
  shopId: string;
  shopName: string;
  goodsId: string;
  goodsName: string;
}

interface IState {
  searchList: any[];
  search: Search;
  isLoading: boolean;
}

const initialArgs: IState = {
  searchList: [],
  search: new Search(),
  isLoading: false,
};

function reducer(state: IState, { type, payload }: Dispatch) {
  switch (type) {
    case "isloading": {
      state.isLoading = payload;
      return { ...state };
    }
    case "SetSearch":
      return {
        ...state,
        search: {
          ...state.search,
          ...payload,
        },
      };
    case "SetSearchList":
      return {
        ...state,
        searchList: payload,
      };
    default:
      return state;
  }
}

export function WarehousingStoreProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialArgs);

  const v = { state, dispatch };
  return (
    <WarehousingStore.Provider value={v}>
      {props.children}
    </WarehousingStore.Provider>
  );
}
